module.exports = __webpack_public_path__ + "img/enerman_etsol.e3bc5bc4.svg";